module.exports = __webpack_public_path__ + "media/images/top/img_interview_fukkyy-c3242b30355d2f56bb510c8e5aa94836.jpg";